import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AddActionComponent } from '../../add-action/add-action.component';
import { Store } from '@ngrx/store';
import { triggerAddAction } from 'src/app/shared/ngrxState/Actions/continue-conv.actions';

@Component({
  selector: 'app-popup-action',
  templateUrl: './popup-action.component.html',
  styleUrls: ['./popup-action.component.scss'],
})
export class PopupActionComponent implements OnInit {
  idBOT: any;
  botType: any;
  isTheme: any;
  built: any;
  show: any;
  event: any;
  intention: any;
  builtTemplate: any;
  rang: any;
  promptList: any;
  parent: string;
  selectedNodeId: string;
  suggestName: string;
  typeFollowUp: any;
  typeMarketing: any;
  flowName?: string;
  constructor(
    public DialogRef: MatDialogRef<AddActionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private store: Store,
  ) {
    this.idBOT = data.idBOT;
    this.botType = data.botType;
    this.isTheme = data.isTheme;
    this.built = data.built;
    this.show = data.show;
    this.event = data.event;
    this.builtTemplate = data.builtTemplate;
    this.intention = data.intention;
    this.promptList = data.promptList;
    this.parent = data.parent;
    this.suggestName = data.suggestName;
    this.typeFollowUp = data.typeFollowUp;
    this.typeMarketing = data.typeMarketing;
    this.flowName = data.flowName;
    this.selectedNodeId = data.selectedNodeId;
    //this.rang = data.rang
  }

  ngOnInit() {
    this.DialogRef.updateSize('fit-content', 'fit-content');
  }
  onCloseClick() {
    this.DialogRef.close();
    this.store.dispatch(triggerAddAction({ triggerAddActionFlag: false }));
  }
}
